import Component from '../abstracts/Component';
import { trapFocusOnModal } from '../utils/TrapFocus';
import OnDemandLiveRegion from '../utils/OnDemandLiveRegion';

export default class HeaderComponent extends Component {

  get SELECTORS() {
    return {
      stickyHeader: '[data-sticky-header]',
      burgerMenu: '[data-trigger-menu]',
      navBar: '[data-navbar]',
      backMainMenu: '[data-close-menu-layers]',
      submenuLinks: "[data-menu-submenu='true']",
      menuLayers: '[data-menu-layers]',
      menuSubLayers: '[data-menu-panel]',
      headerMenu: '[data-header-menu]',
      searchBtn: '[data-trigger-search]',
      searchLayer: '[data-search-layer]',
      searchLayerInput: '[data-search-layer] .search-layer__form .aa-Input',
      searchCloseBtn: '[data-close-search]',
      redirectLink: '[data-card-href]',
      wishlistIcon: '[data-wishlist-icon]',
      wishlistCounter: '[data-wishlist-qty]',
      myaccountIcon: '#myaccount-header',
      loggedAccountButton: '[data-myaccount-button-show]'
    };
  }

  get CSS_CUSTOMVARS() {
    return {
      headerHeight: '--js-header-height',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.headerHeight = this.$component ? this.$component.offsetHeight - 1 : 0;
    this.handleSubmenuEscape = this.handleSubmenuEscape.bind(this);
    // to reset focus after close submenu
    this.originalSubmenuLink = null;
    // for mobile menu trap focus
    this.mobileMenuTrapHandler = null;
  }

  readDOM() {
    return {
      stickyHeader: document.querySelector(this.SELECTORS.stickyHeader),
      headerMenu: document.querySelector(this.SELECTORS.headerMenu),
      burgerMenu: this.$component.querySelector(this.SELECTORS.burgerMenu),
      navBar: this.$component.querySelector(this.SELECTORS.navBar),
      searchBtn: this.$component.querySelector(this.SELECTORS.searchBtn),
      searchLayer: document.querySelector(this.SELECTORS.searchLayer),
      searchLayerInput: document.querySelector(this.SELECTORS.searchLayerInput),
      searchCloseBtn: document.querySelector(this.SELECTORS.searchCloseBtn),
      submenuLinks: this.$component.querySelectorAll(this.SELECTORS.submenuLinks),
      menuLayers: document.querySelector(this.SELECTORS.menuLayers),
      backMainMenu: document.querySelector(this.SELECTORS.backMainMenu),
      redirectLinks: document.querySelectorAll(this.SELECTORS.redirectLink),
      wishlistIcon: this.$component.querySelectorAll(this.SELECTORS.wishlistIcon),
      wishlistCounter: this.$component.querySelectorAll(this.SELECTORS.wishlistCounter),
      myaccountIcon: this.$component.querySelector(this.SELECTORS.myaccountIcon),
      loggedAccountButton: this.$component.querySelector(this.SELECTORS.loggedAccountButton),
      currentMenuEnabled: null,
      currentSubmenuEnabled: null,
      isMobileMenuOpen: false
    }
  }

  // FIRST LEVEL MENU //
  handleMobileMenu() {
    if (this.dom.burgerMenu) {
      this.dom.burgerMenu.addEventListener("click", () => {
        this.toggleMobileMenu();
        // communication popup timer events //
        if (this.dom.isMobileMenuOpen) {
          // communication popup resume timer //
          this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
        } else {
          // communication popup stop timer //
          this.$emit(this.$customEvents.POPUP_EVENTS.resumeTimer);
        }
        if (window.innerWidth < 1024) {
          this.$emit(this.$customEvents.MENU_EVENTS.showMenu);
        }
      });
    }
  }

  toggleMobileMenu() {
    const benefitBars = document.querySelectorAll("[data-benefit-bar]");
    if (benefitBars) {
      benefitBars.forEach(benefitBar => {
        benefitBar.classList.toggle("hidden");
      });
    }
    const headerMenuHeight = this.dom.headerMenu.clientHeight;
    this.dom.navBar.style.top = headerMenuHeight + "px";
    const navbarHeight = window.innerHeight - headerMenuHeight;
    this.dom.navBar.style.height = navbarHeight + "px";
    this.dom.headerMenu.parentElement.classList.toggle('--overlap');
    this.dom.navBar.classList.toggle("--opened");
    this.dom.navBar.classList.toggle("--closed");
    this.dom.burgerMenu.classList.toggle("--opened");
    this.dom.menuLayers.classList.add("--closed");
    document.body.classList.toggle("--no-overflow");
    if (this.dom.currentSubmenuEnabled) {
      this.dom.currentSubmenuEnabled.classList.add("hidden");
      this.dom.currentSubmenuEnabled = null;
    }

    // Handle mobile menu state and trap focus
    if (this.dom.isMobileMenuOpen) {
      this.dom.isMobileMenuOpen = false;
      this.removeMobileMenuTrapFocus();
    } else {
      this.dom.isMobileMenuOpen = true;
      // Only apply trap focus in mobile view
      if (window.innerWidth < 1024) {
        this.applyMobileMenuTrapFocus();
      }
    }
  }

  // if screen size is table/mobile set navbar height otherwise reset it
  handleMobileMenuHeight() {
    this.setCustomVar();
    window.addEventListener("resize", () => {
      this.headerHeight = this.$component.offsetHeight - 1;
      this.setCustomVar();
      if (this.dom.navBar) {
        if (window.innerWidth < 1024) {
          const headerMenuHeight = this.dom.headerMenu.clientHeight;
          const navbarHeight = window.innerHeight - headerMenuHeight;
          this.dom.navBar.style.height = navbarHeight + "px";
        } else {
          this.dom.navBar.style.height = "";
          // Remove trap focus when switching to desktop
          if (this.dom.isMobileMenuOpen) {
            this.removeMobileMenuTrapFocus();
          }
        }
      }
    })
  }

  // SUBMENU HANDLE //
  handleSubmenuLinks() {
    if (this.dom.submenuLinks) {
      this.dom.submenuLinks.forEach(submenuLink => {
        submenuLink.addEventListener("click", (event) => {
          if (this.dom.currentMenuEnabled === event.currentTarget) {
            this.handleClickOnOpenSubmenuLink(event);
          } else {
            // if this.dom.currentMenuEnabled then remove --active and empty field
            if (this.dom.currentMenuEnabled) {
              this.dom.currentMenuEnabled.classList.remove("--active");
              this.dom.currentMenuEnabled = null;
            }
            //if this.dom.currentSubmenuEnabled then hide and empty field
            if (this.dom.currentSubmenuEnabled) {
              this.dom.currentSubmenuEnabled.classList.add("hidden");
              this.removeEventListener();
              this.dom.currentSubmenuEnabled = null;
            }
            this.dom.menuLayers.classList.remove("--closed");
            const submenuName = submenuLink.dataset.menuItem;
            const submenuPanel = document.querySelector("[data-menu-panel='" + submenuName + "']");
            if (submenuPanel) {
              submenuPanel.classList.remove("hidden");
              this.dom.currentSubmenuEnabled = submenuPanel;

              // to reset focus after close submenu
              submenuLink.classList.add("--active");
              this.dom.currentMenuEnabled = submenuLink;
              this.originalSubmenuLink = submenuLink;

              // trapfocus management
              trapFocusOnModal(submenuPanel);

              // If we're in mobile and mobile menu is open, remove mobile menu trap focus
              // since now the submenu has its own trap focus
              if (window.innerWidth < 1024 && this.dom.isMobileMenuOpen) {
                this.removeMobileMenuTrapFocus();
              }

              // escape management submenu
              submenuPanel.addEventListener("keydown", this.handleSubmenuEscape);

              // handle click outside menu layer in desktop //
              if (window.innerWidth >= 1024) {
                event.stopPropagation();
                document.addEventListener("click", this.handleClickOutsideSubmenuLayer.bind(this));
              } else {
                this.dom.menuLayers.style.top = this.dom.menuLayers.getBoundingClientRect().top + "px";
                this.dom.menuLayers.style.position = "fixed";
                this.dom.menuLayers.style.bottom = "0";
              }
              // communication popup pause timer //
              this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
              document.body.dataset.jsLayerIsOpen = "true";
            }
            //close search layer
            this.dom.searchLayer.classList.remove("--opened");
          }
        });
      });
    }
  }

  handleClickOutsideSubmenuLayer(event) {
    if (this.dom.currentSubmenuEnabled && !this.dom.currentSubmenuEnabled.contains(event.target)) {
      this.closeSubmenu();
    }
  }

  handleClickOnOpenSubmenuLink(event) {
    this.closeSubmenu();
  }

  removeEventListener() {
    document.removeEventListener("click", this.handleClickOutsideSubmenuLayer);
    if (this.dom.currentSubmenuEnabled) {
      this.dom.currentSubmenuEnabled.removeEventListener("keydown", this.handleSubmenuEscape);
    }
  }

  // Manage escape to close submenu
  handleSubmenuEscape(e) {
    if (e.key === "Escape") {
      this.closeSubmenu();
    }
  }

  closeSubmenu() {
    if (this.dom.currentSubmenuEnabled) {
      this.dom.currentSubmenuEnabled.classList.add("hidden");
      this.dom.currentSubmenuEnabled = null;
    }
    this.dom.menuLayers.classList.add("--closed");

    if (this.dom.currentMenuEnabled) {
      this.dom.currentMenuEnabled.classList.remove("--active");
      this.dom.currentMenuEnabled = null;
    }

    this.removeEventListener();
    this.$emit(this.$customEvents.POPUP_EVENTS.resumeTimer);
    document.body.dataset.jsLayerIsOpen = "false";

    // reset focus
    if (this.originalSubmenuLink) {
      setTimeout(() => {
        // find focusable element
        const focusableElement = this.originalSubmenuLink.querySelector('a, button, [tabindex]:not([tabindex="-1"])');

        if (focusableElement) {
          focusableElement.focus();
        }
        this.originalSubmenuLink = null;

        // If we're in mobile and mobile menu is still open, re-apply trap focus to mobile menu
        if (window.innerWidth < 1024 && this.dom.isMobileMenuOpen) {
          this.applyMobileMenuTrapFocus();
        }
      }, 50);
    }
  }

  closeMobileSubmenu() {
    if (this.dom.backMainMenu) {
      this.dom.backMainMenu.addEventListener("click", () => {
        this.closeSubmenu();
      });
    }
  }

  // MOBILE MENU TRAP FOCUS //
  applyMobileMenuTrapFocus() {
    if (this.dom.navBar && window.innerWidth < 1024) {
      this.mobileMenuTrapHandler = trapFocusOnModal(this.dom.navBar);

      // Add escape key handler for mobile menu
      this.handleMobileMenuEscape = this.handleMobileMenuEscape.bind(this);
      document.addEventListener("keydown", this.handleMobileMenuEscape);
    }
  }

  removeMobileMenuTrapFocus() {
    if (this.mobileMenuTrapHandler && this.dom.navBar) {
      // trapFocusOnModal doesn't return a removable handler, so we need to handle removal manually
      this.dom.navBar.removeAttribute("tabindex");
      this.mobileMenuTrapHandler = null;

      // Remove escape key handler
      if (this.handleMobileMenuEscape) {
        document.removeEventListener("keydown", this.handleMobileMenuEscape);
      }
    }
  }

  // Handle escape key to close mobile menu
  handleMobileMenuEscape(e) {
    if (e.key === "Escape" && this.dom.isMobileMenuOpen && window.innerWidth < 1024) {
      this.toggleMobileMenu();
      // Return focus to burger menu button
      if (this.dom.burgerMenu) {
        this.dom.burgerMenu.focus();
      }
    }
  }

  // HANDLE SUBMENU CARDS //
  handleRedirectLink() {
    if (this.dom.redirectLinks) {
      this.dom.redirectLinks.forEach(link => {
        link.addEventListener("click", () => {
          window.location.href = link.dataset.cardHref;
        });
      });
    }
  }

  // to close search layer
  closeSearchLayer() {
    this.dom.searchLayer.classList.remove("--opened");
    this.$emit(this.$customEvents.POPUP_EVENTS.resumeTimer);
    document.body.dataset.jsLayerIsOpen = "false";
    if (window.matchMedia('(max-width: 768px)').matches) {
      document.body.classList.remove("--no-overflow");
      const benefitBars = document.querySelectorAll("[data-benefit-bar]");
      if (benefitBars) {
        benefitBars.forEach(benefitBar => {
          benefitBar.classList.remove("hidden");
        });
      }
    }
    // reset focus
    if (this.dom.searchBtn) {
      this.dom.searchBtn.focus();
    }
  }


  // SEARCH LAYER //
  handleSearchLayer() {
    if (this.dom.searchBtn) {
      // focus the input (call readDOM() because algolia input arrives after render)
      this.dom.searchLayer.addEventListener("transitionend", (event) => {
        if (
          this.dom.searchLayer.classList.contains("--opened") &&
          this.readDOM().searchLayerInput
        ) {
          this.readDOM().searchLayerInput.focus();
        }
      });

      // management escape to exit from layer
      this.dom.searchLayer.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && this.dom.searchLayer.classList.contains("--opened")) {
          this.closeSearchLayer();
        }
      });

      // management close button to exit from layer
      if (this.dom.searchCloseBtn) {
        this.dom.searchCloseBtn.addEventListener("click", () => {
          this.closeSearchLayer();
        });
      }

      this.dom.searchBtn.addEventListener("click", () => {
        // layer is closed --> add --opened
        if (!this.dom.searchLayer.classList.contains("--opened")) {
          this.dom.searchLayer.classList.add("--opened");
          // focus the input (call readDOM() because algolia input arrives after render)
          this.readDOM().searchLayerInput ? this.readDOM().searchLayerInput.focus() : '';

          // trapfocus management added
          if (this.dom.searchLayer) {
            trapFocusOnModal(this.dom.searchLayer);
          }

          // communication popup stop timer //
          this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
          document.body.dataset.jsLayerIsOpen = "true";
          if (window.matchMedia('(max-width: 768px)').matches) {
            document.body.classList.add("--no-overflow");
            const benefitBars = document.querySelectorAll("[data-benefit-bar]");
            if (benefitBars) {
              benefitBars.forEach(benefitBar => {
                benefitBar.classList.add("hidden");
              });
            }
          }
          //in mobile close menu
          if (window.innerWidth < 1024 && this.dom.isMobileMenuOpen) {
            this.toggleMobileMenu();
          }
        }
      });
    }
  }

  // WISHLIST API //
  updateWishlistCounter(qty) {
    if (this.dom.wishlistCounter) {
      this.dom.wishlistCounter.forEach(wishlistCounter => {
        wishlistCounter.dataset.wishlistQty = qty;
        if (parseInt(qty, 10) > 0) {
          wishlistCounter.classList.remove("hidden");
        } else {
          wishlistCounter.classList.add("hidden");
        }
      });
    }
  }

  bindEvents() {
    this.handleMobileMenu();
    this.handleMobileMenuHeight();
    this.handleSearchLayer();
    this.handleSubmenuLinks();
    this.closeMobileSubmenu();
    this.handleRedirectLink();
    this.showAccountLayerWithChevronButton();
    this.handleKeyboardInputOnAccountLayer();
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish, ({ event, payload }) => {
      // The != check for both null and undefined. This way 0 is permitted
      if (payload.qty != null) {
        this.updateWishlistCounter(payload.qty);
      }
    });
    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, ({ event, payload }) => {
      // The != check for both null and undefined. This way 0 is permitted
      if (payload.qty != null) {
        this.updateWishlistCounter(payload.qty);
      }
    });
    if (this.dom.myaccountIcon) {
      this.dom.myaccountIcon.addEventListener("mouseover", event => {
        this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
      });
      this.dom.myaccountIcon.addEventListener("mouseout", event => {
        if (document.body.dataset.jsLayerIsOpen == "false") {
          this.$emit(this.$customEvents.POPUP_EVENTS.resumeTimer);
        }
      });
    }
  }

  setCustomVar() {
    const root = document.documentElement;
    root.style.setProperty(this.CSS_CUSTOMVARS.headerHeight, `${this.headerHeight}px`);
  }

  /* scrolling effect */
  handleScroll() {
    window.addEventListener('scroll', (e) => {
      this.headerHeight = this.$component.offsetHeight - 1;
      this.setCustomVar();
    });
  }

  showAccountLayerWithChevronButton() {
    const ctx = this;
    if (this.dom.loggedAccountButton) {
      this.dom.loggedAccountButton.addEventListener("click", () => {
        const isOpening = !ctx.dom.myaccountIcon.classList.contains("--opened");
        ctx.dom.myaccountIcon.classList.toggle("--opened");

        // Announce to screen readers when account layer opens/closes
        if (ctx.liveRegion && ctx.dom.myaccountIcon) {
          const message = isOpening
            ? ctx.dom.myaccountIcon.dataset.msgOpened
            : ctx.dom.myaccountIcon.dataset.msgClosed;

          if (message) {
            ctx.liveRegion.sayMessage(message);
          }
        }
      });
    }
  }

  handleKeyboardInputOnAccountLayer() {
    const comp = this;
    const el = this.$component.querySelector('.l-my-account');
    el && trapFocusOnModal(el);
    el?.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        comp.dom.myaccountIcon.classList.remove("--opened");
        comp.dom.loggedAccountButton.focus();
      }
    });
  }

  render() {
    super.render();
    this.dom = this.readDOM();
     if (!this.liveRegion) {
          this.liveRegion = new OnDemandLiveRegion({
            level: 'assertive',
            parent: 'body',
            idPrefix: 'user-logged-live-region-',
            delay: 100
          });
        }
    this.bindEvents();
  }
}
